import React from "react";
import ExcoPusat from "../../components/organism/ExcoPusat";

const PageExcoPusat = () => {
  return (
    <>
      <ExcoPusat />
    </>
  );
};

export default PageExcoPusat;
